import { ROUTER_ABOUT_US, ROUTER_TERMS_PRIVACY_POLICY, ROUTER_TERMS_SERVICE } from "@/entry/route";
import React from "react";
import config from 'config'
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation('app', { keyPrefix: 'pages.welcome.footer' });
  const mediaLinks = [
    { href: config.douyin, label: t('douyin') },
    { href: config.xiaohongshu, label: t('xiaohongshu') },
    { href: config.gongzhonghao, label: t('gongzhonghao') },
  ].filter(item => !!item.href);

  const hasBeian = !!config.beian

  return (
    <footer className="bg-white">
      <div className="container mx-auto px-8">
        <div className="w-full flex flex-col md:flex-row py-6">
          <div className="flex-1 mb-6 text-black">
            <a className="text-pink-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" href="#">
              {config.product}
            </a>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">{t('links')}</p>
            <ul className="list-reset mb-6">
              {/* <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href="#" className="no-underline hover:underline text-gray-800 hover:text-pink-500">问题</a>
              </li> */}
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href="#" className="no-underline hover:underline text-gray-800 hover:text-pink-500">{t('help_center')}</a>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href="#" className="no-underline hover:underline text-gray-800 hover:text-pink-500">{t('support')}</a>
              </li>
            </ul>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">{t('terms')}</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href={ROUTER_TERMS_SERVICE} className="no-underline hover:underline text-gray-800 hover:text-pink-500">{t('term_of_service')}</a>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href={ROUTER_TERMS_PRIVACY_POLICY} className="no-underline hover:underline text-gray-800 hover:text-pink-500">{t('privacy_policy')}</a>
              </li>
            </ul>
          </div>
          {mediaLinks.length > 0 && (
            <div className="flex-1">
              <p className="uppercase text-gray-500 md:mb-6">{t('media')}</p>
              <ul className="list-reset mb-6">
                {mediaLinks.map(item => (
                  <li key={item.label} className="mt-2 inline-block mr-2 md:block md:mr-0">
                    <a href={item.href} className="no-underline hover:underline text-gray-800 hover:text-pink-500">{item.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">{t('company')}</p>
            <ul className="list-reset mb-6">
              {/* <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href="#" className="no-underline hover:underline text-gray-800 hover:text-pink-500">博客</a>
              </li> */}
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href={ROUTER_ABOUT_US} className="no-underline hover:underline text-gray-800 hover:text-pink-500">{t('about_us')}</a>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a href={ROUTER_ABOUT_US + '#contact'} className="no-underline hover:underline text-gray-800 hover:text-pink-500">{t('contact_us')}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="text-center text-sm text-gray-500 py-4">
        <span className='item'>{config.product}@{config.now}</span>
        {hasBeian && (
          <>
            <span className='item'>&nbsp;|&nbsp;</span>
            <span className='item'><a href="https://beian.miit.gov.cn/" target="_blank">{config.beian}</a></span>
          </>
        )}
      </p>
    </footer>
  )
}
